/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Autoplays all videos throughout the entire website
  document.addEventListener('DOMContentLoaded', function() {
    // Select all deferred media elements
    const deferredMediaElements = document.querySelectorAll('[data-deferred-media]');
  
    // Function to load and play the media
    function loadAndPlayMedia(element) {
      if (element.getAttribute('data-loaded')) return;
  
      const template = element.querySelector('template');
      if (!template) return;
  
      const content = document.createElement('div');
      content.appendChild(template.content.firstElementChild.cloneNode(true));
      const mediaElement = content.querySelector('video, iframe');
  
      if (mediaElement) {
        element.appendChild(mediaElement);
        element.setAttribute('data-loaded', true);
        if (mediaElement.tagName === 'VIDEO') {
          mediaElement.play();
        } else if (mediaElement.tagName === 'IFRAME') {
          // For iframe, assuming it is a YouTube video
          const iframeSrc = mediaElement.src;
          mediaElement.src = iframeSrc + (iframeSrc.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        }
      }
    }
  
    // Iterate over each deferred media element and load and play it
    deferredMediaElements.forEach(function(element) {
      loadAndPlayMedia(element);
    });
  });

  // Custom function for the navigation indicators added to "Products List" module/section
  document.addEventListener('DOMContentLoaded', function() {
    const navButtons = document.querySelectorAll('.products-list__nav__button');
    const indicators = document.querySelectorAll('.products-list__container .dot');

    navButtons.forEach((button, index) => {
      button.addEventListener('click', function(event) {
        event.preventDefault(); 
        navButtons.forEach(btn => btn.classList.remove('products-list__nav__button--active'));
        button.classList.add('products-list__nav__button--active');
        indicators.forEach(indicator => indicator.classList.remove('is-selected'));
        indicators[index].classList.add('is-selected');
      });
    });

    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', function(event) {
        event.preventDefault(); 
        // Simulate click on the corresponding navigation button
        navButtons[index].click();
      });
    });
  });


  // // Handles the visibility of the low stock banner based on the selected product variant in product pages
  // document.addEventListener('DOMContentLoaded', () => {
  //     const variantSelect = document.querySelector('[name="id"]');
  //     let selectedVariantId = variantSelect.value;
    
  //     // Hide all low stock warnings initially
  //     document.querySelectorAll('.product__low_stock').forEach(el => {
  //       // Uncomment the lines below for debugging to log the inventory quantity and corresponding variant ID.
  //       const variantId = el.getAttribute('data-variant-id');
  //       console.log(`Variant ID: ${variantId}, Inventory: ${el.getAttribute('data-inventory-quantity')}`);
  //       el.style.display = 'none';
  //     });
    
  //     // Show the low stock warning for the initially selected variant
  //     const initialLowStockElement = document.querySelector(`.product__low_stock[data-variant-id="${selectedVariantId}"]`);
  //     if (initialLowStockElement) {
  //       initialLowStockElement.style.display = 'block';
  //     }
    
  //     // Listen for changes in the variant selection
  //     variantSelect.addEventListener('change', (event) => {
  //       selectedVariantId = event.target.value;
    
  //       // Hide all low stock warnings
  //       document.querySelectorAll('.product__low_stock').forEach(el => el.style.display = 'none');
    
  //       // Show the low stock warning for the selected variant
  //       const lowStockElement = document.querySelector(`.product__low_stock[data-variant-id="${selectedVariantId}"]`);
  //       if (lowStockElement) {
  //         lowStockElement.style.display = 'block';
  //       }
  //     });
  //   });  
  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// document.addEventListener('click', function (event) {
//     const button = event.target.closest('.esperance-banner .main-buttons__item .btn');
//     if (!button) return;
//     event.preventDefault();
//     window._klOnsite = window._klOnsite || [];
//     window._klOnsite.push(['openForm', 'TUVzm9']);
// });

// document.addEventListener('click', function (event) {
//     const button = event.target.closest('.bday-banner-campaign .main-buttons__item .btn');
//     if (!button) return;
//     event.preventDefault();
//     window._klOnsite = window._klOnsite || [];
//     window._klOnsite.push(['openForm', 'Wm3ixj']);
// });

// document.addEventListener('click', function (event) {
//     const button = event.target.closest('.countdown-set .main-buttons__item .btn');
//     if (!button) return;
//     event.preventDefault();
//     window._klOnsite = window._klOnsite || [];
//     window._klOnsite.push(['openForm', 'Wm3ixj']);
// });

// document.addEventListener('click', function (event) {
//     const button = event.target.closest('.live-banner-campaign .main-buttons__item .btn');
//     if (!button) return;
//     event.preventDefault();
//     window._klOnsite = window._klOnsite || [];
//     window._klOnsite.push(['openForm', 'Wm3ixj']);
// });



